import { parse, isValid, addDays, isAfter } from 'date-fns';
export const isValidMnpExpiration = (value) => {
    if (value) {
        if (!value.match(/^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])$/)) {
            return {
                valid: Boolean(false),
                name: 'invalid_mnp_expiration'
            };
        }
        const parsedDate = parse(value, 'MM/dd', new Date());
        // 有効な日付か
        if (!isValid(parsedDate)) {
            return {
                valid: Boolean(false),
                name: 'invalid_mnp_expiration'
            };
        }
        // 10日以上先の日付か
        if (!isMoreThanTenDaysInFuture(parsedDate)) {
            return {
                valid: Boolean(false),
                name: 'mnp_expiration_not_more_than_ten_days'
            };
        }
    }
    return { valid: Boolean(true), name: '' };
};
const isMoreThanTenDaysInFuture = (targetDate) => {
    const tenDaysFromNow = addDays(new Date(), 10);
    return isAfter(targetDate, tenDaysFromNow);
};
export const isValidMnpTelNo = (value) => {
    if (value) {
        // 11or14桁の半角数字 （先頭090,080,070,020以外はNG)
        if (!value.match(/^(090|080|070|020)\d{8}(?:\d{3})?$/)) {
            return {
                valid: Boolean(false),
                name: 'invalid_mnp_tel_no'
            };
        }
    }
    return { valid: Boolean(true), name: '' };
};
export const isValidMnpNo = (value) => {
    if (value) {
        // 11始まりの10桁の半角数字
        if (!value.match(/^11[0-9]{8}$/)) {
            return {
                valid: Boolean(false),
                name: 'invalid_mnp_no'
            };
        }
    }
    return { valid: Boolean(true), name: '' };
};
export const isValidTelNo = (value) => {
    if (value) {
        // 0始まり、10、11桁の半角数字
        if (!value.match(/^0\d{9}$|^0\d{10}$/)) {
            return {
                valid: Boolean(false),
                name: 'invalid_tel_no'
            };
        }
    }
    return { valid: Boolean(true), name: '' };
};
export const isValidBirthDate = (value) => {
    if (value) {
        if (!value.match(/^(\d{4})(\d{2})(\d{2})$/)) {
            return {
                valid: Boolean(false),
                name: 'invalid_date'
            };
        }
        const date = parse(value, 'yyyyMMdd', new Date());
        if (!isValid(date)) {
            return {
                valid: Boolean(false),
                name: 'invalid_date'
            };
        }
        const minDate = new Date(1900, 0, 1);
        const isAfterMinDate = isAfter(date, minDate) || date.getTime() === minDate.getTime();
        if (!isAfterMinDate) {
            return {
                valid: Boolean(false),
                name: 'invalid_date'
            };
        }
    }
    return { valid: Boolean(true), name: '' };
};
export const isValidZipcode = (value) => {
    if (value) {
        if (!value.match(/^\d{7}$/)) {
            return {
                valid: Boolean(false),
                name: 'invalid_zipcode'
            };
        }
    }
    return { valid: Boolean(true), name: '' };
};
export const isZenkaku = (value) => {
    if (value) {
        const regex = /^[^ -~｡-ﾟ]+$/;
        return {
            valid: regex.test(value),
            name: 'not_zenkaku'
        };
    }
    return { valid: Boolean(true), name: '' };
};
export const isZenkakuKana = (value) => {
    if (value) {
        const regex = /^[ア-ンヴヵヶー]*$/;
        return {
            valid: regex.test(value),
            name: 'not_zenkaku_kana'
        };
    }
    return { valid: Boolean(true), name: '' };
};
export const isValidSimSerialNo = (value) => {
    if (value) {
        // 半角英数字15文字
        if (!value.match(/^[a-zA-Z0-9]{15}$/)) {
            return {
                valid: Boolean(false),
                name: 'invalid_sim_serial_no'
            };
        }
    }
    return { valid: Boolean(true), name: '' };
};
